// Smoothly scrolls to a section by id, honouring reduced motion, and keeps the URL hash in sync.
export const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId)
    if (!element) return

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    element.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' })
    window.history.replaceState(null, '', `#${sectionId}`)
}
